var map = {
	"./Account.vue": [
		"77be",
		"chunk-2d0d7c19"
	],
	"./Home.vue": [
		"bb51"
	],
	"./PrivateCatalog.vue": [
		"5052",
		"chunk-5467fd4e",
		"chunk-2d0c736e"
	],
	"./ProductCatalog.vue": [
		"1667",
		"chunk-5467fd4e",
		"chunk-53002457"
	],
	"./ShoppingCart.vue": [
		"8c6e",
		"chunk-3baa55c0"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;